// extracted by mini-css-extract-plugin
module.exports = {"sidebarWrapper":"MvtAVeMg","filterSidebar":"_1nXICpNn","hidden":"_2YWkCqCF"};